import i18n from '/common/plugins/vue-i18n.js' 
let lang = window.localStorage.getItem('language');
if(!lang)	
{
    lang = "zh_TW"				
}
i18n.locale = lang


const orders_SP_FieldList = [
    // { key:'created_on', name: i18n.t('OPPTYSFIELDLIST.created_on') ,type:'date'},
	// { key:'created_by', name: i18n.t('OPPTYSFIELDLIST.created_by') ,type:'user'},
	// { key:'updated_on', name: i18n.t('OPPTYSFIELDLIST.updated_on') ,type:'date'},
	// { key:'updated_by',name: i18n.t('OPPTYSFIELDLIST.updated_by') ,type:'user'},
	// { key:'owner',name: i18n.t('OPPTYSFIELDLIST.owner') ,type:'user'},
	{ key:'order_name',name: i18n.t(`ORDER.WIADVANCE_NAME`) ,type:'text'},
	{ key:'order_status',name: i18n.t('ORDER.ORDER_STATUS') ,type:'opt'},
	{ key:'serviceproductitem_sale_name',name: i18n.t('ORDER.ORDER_SALES') ,type:'user'},
	{ key:'remain_day',name: i18n.t('ORDER.FROM_DATE') ,type:'num'},
	{ key:'end_account_name',name: i18n.t('ORDER.ENDACCOUNT') ,type:'text'},
	{ key:'serviceproductitem_contact_name',name: i18n.t('ORDER.CONTACT_NAME') ,type:'fk_contact'},
	// { key:'serviceproductitem_contact_second_name',name: i18n.t('ORDER.CONTACT_NAME')+" 2",type:'fk_contact'},
	// { key:'serviceproductitem_contact_third_name',name: i18n.t('ORDER.CONTACT_NAME')+" 3",type:'fk_contact'},
	{ key:'product_type_name',name: i18n.t('ORDER.TYPE') ,type:'opt'},
	{ key:'project_name',name: i18n.t('ORDER.PROJECT_NAME') ,type:'text'},
	{ key:'sla',name: 'SLA' ,type:'opt'},
	{ key:'service_content',name: i18n.t('ORDER.SERVICE_CONTENT') ,type:'text'},
	{ key:'start_date',name: i18n.t('ORDER.START_DATE') ,type:'date'},
	{ key:'end_date',name: i18n.t('ORDER.DUE_DATE') ,type:'date'},
	{ key:'service_plan',name: i18n.t('ORDER.SERVICE_PLAN') ,type:'opt'},
	{ key:'status',name: i18n.t('ORDER.STATUS') ,type:'opt'},
	{ key:'note',name: i18n.t('ORDER.NOTE') ,type:'text'},
	{ key:'sales_order',name: 'SO' ,type:'text'},
	{ key:'sales_order_line',name: 'SO Line' ,type:'text'},
	{ key:'purchase_order',name: "PO" ,type:'text'},
	{ key:'project_code',name: i18n.t('ORDER.PROJECT_CODE') ,type:'text'},
];
export default orders_SP_FieldList;